import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';

import { AutenticacionService } from '../../shared/services/autenticacion.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(private autenticacionService: AutenticacionService) { }

  intercept(httpRequest: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.autenticacionService.estaAutenticado()) {
      // const request = httpRequest.clone({ params: httpRequest.params.set('Authorization', `Bearer ${this.autenticacionService.getToken()}`) });
      const request = httpRequest.clone({ headers: httpRequest.headers.set('Authorization', `Bearer ${this.autenticacionService.getToken()}`) });

      return next.handle(request);
    }
    return next.handle(httpRequest);
  }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/QA/HistoricoConductor/frontend/src/app/core/interceptors/token.interceptor.ts